module.exports = __webpack_public_path__ + "static/media/satGood.8c45463d.png";